import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import './EquipmentConsumption.css';

const EquipmentConsumption = () => {
    const [equipmentData, setEquipmentData] = useState([]);
    const [equipmentName, setEquipmentName] = useState('');
    const [quantity, setQuantity] = useState('');
    const [power, setPower] = useState('');
    const [time, setTime] = useState('');
    const navigate = useNavigate();

    const handleWheel = (e) => {
        if (e.target.type === 'number') {
            e.preventDefault();
        }
    };

    React.useEffect(() => {
        window.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            window.removeEventListener('wheel', handleWheel);
        };
    }, []);

    const handleAddEquipment = async (e) => {
        e.preventDefault();

        if (equipmentName && quantity && power && time) {
            const totalPowerValue = quantity * power;
            const totalEnergyValue = totalPowerValue * time;

            const newEquipment = {
                name: equipmentName,
                quantity: Number(quantity),
                power: Number(power),
                time: Number(time),
                totalPower: totalPowerValue,
                totalEnergy: totalEnergyValue,
            };

            try {
                await addDoc(collection(db, 'Equipos'), newEquipment);
                setEquipmentData([...equipmentData, newEquipment]);
                Swal.fire({
                    title: 'Éxito',
                    text: 'Equipo registrado con éxito.',
                });
                setEquipmentName('');
                setQuantity('');
                setPower('');
                setTime('');
                navigate('/home');
            } catch (error) {
                console.error('Error al guardar el equipo en la base de datos:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'Hubo un error al registrar el equipo.',
                });
            }
        }
    };

    const navigateToHome = () => {
        navigate('/home');
    };

    return (
        <div className="equipment-consumption-form">
            <h1>Datos de consumo por equipos</h1>
            <form onSubmit={handleAddEquipment}>
                <div className="form-field">
                    <label htmlFor="equipmentName">Nombre del equipo:</label>
                    <input
                        type="text"
                        id="equipmentName"
                        value={equipmentName}
                        onChange={(e) => setEquipmentName(e.target.value)}
                        required
                    />
                </div>
                <div className="form-field">
                    <label htmlFor="quantity">Cantidad:</label>
                    <input
                        type="number"
                        id="quantity"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        min="0"
                        step="any"
                        required
                    />
                </div>
                <div className="form-field">
                    <label htmlFor="power">Potencia (W):</label>
                    <input
                        type="number"
                        id="power"
                        value={power}
                        onChange={(e) => setPower(e.target.value)}
                        min="0"
                        step="any"
                        required
                    />
                </div>
                <div className="form-field">
                    <label htmlFor="time">Tiempo (h):</label>
                    <input
                        type="number"
                        id="time"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        min="0"
                        step="any"
                        required
                    />
                </div>
                <div className="container-button">
                    <button type="submit" className="btn add">
                        Agregar Equipo
                    </button>
                    <button type="button" className="btn back" onClick={navigateToHome}>
                        Salir
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EquipmentConsumption;
